export default "__VITE_ASSET__1c52e0df__"